export default "__VITE_ASSET__DuVxgxhq__"